import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { Icon } from '~/components/ui/icon.tsx';
import { cn } from '~/styles/extended-theme.ts';

export type CheckboxProps = Omit<
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
  'type'
> & {
  type?: string;
};

// see https://github.com/radix-ui/primitives/issues/2402
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'group peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus:bg-primary/40 focus:text-primary-foreground focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      className,
    )}
    {...props}
  >
    {/* Hover checkbox */}
    <div className="hidden items-center justify-center text-current group-hover:flex group-focus-visible:flex group-data-[state=checked]:hidden">
      <Icon name="check" className="h-4 w-4 text-primary/75" />
    </div>

    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <Icon name="check" className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
